module.exports = __webpack_public_path__ + "static/media/hdi-street-selected.97f57df7.svg";